export default "__VITE_ASSET__BnX2TWnl__"